
define('text!modules/targeting/location/templates/bin_footer.html',[],function () { return '<dl class="headers">\n  <dt class="header column name">Geofence Cost</dt>\n  <dd class="header column cpm" data-bind="geofence-cost-cpm">--</dd>\n  <div class="icon-spinner-footer"></div>\n</dl>\n\n';});

